<template>
	<div>
		<v-tooltip bottom v-if="userInfo && userInfo.account">
			<template v-slot:activator="{ on, attrs }">
				<v-icon small color="green" class="mb-1"
					v-bind="attrs"
					v-on="on">mdi-account-circle</v-icon>
			</template>
			<span>Usuario con Cuenta</span>
		</v-tooltip>
		<v-menu
			v-else
			v-model="userAccountMenu"
			offset-y
			offset-x
			left
			:close-on-content-click="false"
			max-width="550"
			min-width="550"
			content-class="menu-bg-white"
			style="z-index: 9999; background-color: white;">
			<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
						<v-btn
							class="mb-1"
							:icon="!large"
							color="warning"
							small
							v-if="large"
							v-bind="{ ...menuAttrs, ...tooltipAttrs }"
							v-on="{ ...menuOn, ...tooltipOn }"
						>
							<v-icon dark small>mdi-account-circle</v-icon>
							<p class="mb-0 ml-2">Asignar Usuario a CRM / Solicitud</p>
						</v-btn>
						<v-icon small color="warning" class="mb-1" v-else
							v-bind="{ ...menuAttrs, ...tooltipAttrs }"
							v-on="{ ...menuOn, ...tooltipOn }">mdi-account-circle</v-icon>
					</template>
					<span>Usuario sin Cuenta Asociada</span>
				</v-tooltip>
			</template>
			<div class="pa-3 caption d-flex justify-center align-center" style="min-height: 150px" v-if="loading">
				Cargando...
			</div>
			<div class="pa-3 caption" v-else-if="userAccount">
				<div class="d-flex justify-space-between align-center">
					<p class="mb-0 font-weight-bold">Asociar Cuenta de Usuario</p>
					<v-btn
						depressed
						color="#524D4D"
						x-small
						icon
						@click="closeMenu"
					>
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</div>
				<p class="mb-0" style="font-size: 10px;">Ya existe una cuenta registrada en el sistema con el correo <b>{{ userInfo.email }}</b>.</p>
				<v-divider class="my-1"></v-divider>
				<p class="mb-0">Al asociar esta solicitud a dicha cuenta, la información del cliente que realizó la solicitud será reemplazada por los datos del usuario seleccionado.</p>
				<div class="d-flex flex-1 align-center mt-2" style="gap: 10px;">
					<div class="flex-1">
						<p class="mb-0 font-weight-bold">Datos del Usuario Solicitante</p>
						<p class="mb-0 d-flex justify-space-between text-right" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;"><b>Nombre:</b> <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;">{{ userInfo.name }} {{ userInfo.lastname }} {{ userInfo.second_lastname }}</span></p>
						<p class="mb-0 d-flex justify-space-between text-right" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;"><b>Email:</b> <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;">{{ userInfo.email }}</span></p>
						<v-btn
							class="mt-2"
							color="#524D4D"
							dark
							block
							small
							outlined
							@click="closeMenu"
						>
							<p class="mb-0">Mantener Sin Asociar</p>
						</v-btn>
					</div>
					<v-divider vertical></v-divider>
					<div class="flex-1">
						<p class="mb-0 font-weight-bold">Datos del Usuario Registrado</p>
						<p class="mb-0 d-flex justify-space-between text-right" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;"><b>Nombre:</b> <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;">{{ userAccount.profile.name }} {{ userAccount.profile.lastname }} {{ userAccount.profile.second_lastname }}</span></p>
						<p class="mb-0 d-flex justify-space-between text-right" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;"><b>Email:</b> <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px;">{{ userAccount.email }}</span></p>
						<v-btn
							class="mt-2"
							color="#524D4D"
							dark
							block
							small
							@click="confirmUser"
						>
							<p class="mb-0">Asociar cliente a esta Cuenta</p>
						</v-btn>
					</div>
				</div>
				<!-- <v-divider class="my-1"></v-divider>
				<div class="d-flex flex-row justify-end">
					<v-btn
						class="mx-2 my-1"
						color="white"
						small
						@click="closeMenu"
					>
						<p class="mb-0 text-primary">Cancelar</p>
					</v-btn>
					<v-btn
						class="mx-2 my-1"
						color="#524D4D"
						dark
						small
					>
						<p class="mb-0">Confirmar</p>
					</v-btn>
				</div> -->
			</div>
			<div v-else class="pa-3 caption">
				<p class="mb-0 font-weight-bold">Crear Cuenta de Usuario</p>
				<v-divider class="my-1"></v-divider>
				<p class="my-2">Al confirmar, se creará una cuenta de usuario para este cliente.</p>
				<v-divider class="my-1"></v-divider>
				<div class="d-flex flex-row justify-end">
					<v-btn
						class="mx-2 my-1"
						color="white"
						small
						@click="closeMenu"
					>
						<p class="mb-0 text-primary">Cancelar</p>
					</v-btn>
					<v-btn
						class="mx-2 my-1"
						color="#524D4D"
						dark
						small
						@click="confirmUser"
					>
						<p class="mb-0">Confirmar</p>
					</v-btn>
				</div>
			</div>
		</v-menu>
	</div>
</template>
<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { getAccountByEmail, associateUserToAccount } from '@/helpers/api/users'

export default {
	name: 'UserAccountSelector',
	props: {
		item: {
			type: Object,
			required: true
		},
		large: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		userInfo(){
			if(this.item.user){
				const user = this.item.user
				if(user && user.user && user.user.profile){
					return {
						name: user.user.profile.name,
						lastname: user.user.profile.lastname,
						second_lastname: user.user.profile.second_lastname,
						email: user.user.email,
						phone: user.user.profile.phone,
						account: true
					}
				}
				return {
					name: user.name,
					lastname: user.lastname,
					second_lastname: user.second_lastname,
					email: user.email,
					phone: user.phone,
				}
			}
			return null
		},
	},
	watch: {
		userAccountMenu(val){
			if(val && !this.userAccount && this.userInfo){
				this.checkUserAccount()
			}
		}
	},
	data() {
		return {
			loading: false,
			userAccountMenu: false,
			userAccount: null
		}
	},
	methods: {
		closeMenu() {
			this.userAccountMenu = false
		},
		async checkUserAccount(){
			this.loading = true
			const data = {
				email: this.userInfo.email
			}
			const user = await getAccountByEmail(data)
			if(user.code == 200){
				this.userAccount = user.user
			}
			this.loading = false
		},
		async confirmUser(){
			const data = {
				bot_conversation_id: this.item.id,
				user_id: this.userAccount?.id,
				user_name: this.userInfo.name,
				user_lastname: this.userInfo.lastname,
				user_second_lastname: this.userInfo.second_lastname,
				user_phone: this.userInfo.phone,
				user_email: this.userInfo.email,
			}
			await associateUserToAccount(data)
			this.closeMenu()
			eventBus.$emit('reloadInformation')
		}
	}
}
</script>